import React from 'react';
import { connect } from 'react-redux';
import {
  Grid, Paper, Typography,
} from '@material-ui/core';
import Lock from '@material-ui/icons/Lock';
import PropTypes from 'prop-types';
import actions from 'shared/actions';
import styles from 'shared/styles';
import Password from './ResetPassword/Password';
import ResetPasswordButton from './ResetPassword/ResetPasswordButton';
import ResetResultModal from './ResetPassword/ResetResultModal';

export function isValidPassword(password) {
  if (password.length < 8 || password.length > 32) {
    return false;
  }

  return true;
}

export function isValidConfirm(password, confirmPassword) {
  return isValidPassword(password) && password === confirmPassword;
}

const centerStyle = { display: 'flex', justifyContent: 'center' };

export function ResetPasswordImpl({ onLoad }) {
  React.useEffect(onLoad, []);
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  return (
    <div style={styles.mainBackground}>
      <ResetResultModal />
      <Paper style={{
        padding: '25px',
        width: '300px',
        borderRadius: '0px',
      }}
      >
        <Grid container spacing={3} alignContent="flex-start">
          <Grid item xs={12} style={centerStyle}>
            <Lock style={{ height: '50px', width: 'auto' }} />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5" style={centerStyle}>
              Reset your password
            </Typography>
          </Grid>
          <Password
            value={password}
            setValue={setPassword}
            placeholder="New password"
            error={!isValidPassword(password)}
          />
          <Grid item xs={12}>
            <Typography style={centerStyle}>
              8-character minimum; case sensitive
            </Typography>
          </Grid>
          <Password
            value={confirmPassword}
            setValue={setConfirmPassword}
            placeholder="Reenter password"
            error={!isValidConfirm(password, confirmPassword)}
          />
          <ResetPasswordButton
            password={password}
            canClick={isValidConfirm(password, confirmPassword)}
          />
        </Grid>

      </Paper>
    </div>
  );
}

ResetPasswordImpl.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

ResetPasswordImpl.defaultProps = {
};

const mapDispatchToProps = {
  onLoad: actions.staging.onLoadShared,
};

export default connect(null, mapDispatchToProps)(ResetPasswordImpl);
